module.exports = __webpack_public_path__ + "static/santorini-min.97f0a5c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructional/santorini-min.jpg
// module id = 150
// module chunks = 66570062548345 213534597649335